module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-4.2c428691.png";